import { useEffect, useState } from "react"
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _AdquisitionItem, _AdquisitionItemBudgetID } from "../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { AdquisitionItemSelector } from "../../../../contract/etapa-contrato/contrac/ublinvoice/AdquisitionItemEditor/AdqusitionItemSelector";
import { BasicButton } from "../../../../theme/Component/BasicButton";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}
export const BPM005 = ({ configProcedure }: Props) => {

    const [invalid, setInvalid] = useState<boolean>(false);
    const [obs, setObs] = useState<string>("");

    const saveSupplier = () => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(obs)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap({ Obs: obs })
        }
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <label>Justifiación:</label>
                <textarea placeholder="Observación minimo 15 caracteres" className={`form-control ${invalid ? "is-invalid" : ""}`} onBlur={() => { setInvalid(false) }} value={obs} onChange={(e) => { setObs(e.target.value) }} />
            </div>

            <div className="col-md-12">
                <div className="row mt-4 ">
                    <div className="col-md-6">
                        <BasicButton disable={obs.length < 16} children={"Continuar"} eventClick={() => {
                            if (obs.length > 15) {
                                saveSupplier()
                            } else {
                                setInvalid(true)
                                toast.error("La observacion debe tener un minimo de 15 caracteres")
                            }
                        }} icon="ri-save-line" />
                    </div>
                </div>
            </div>
        </div>
    )
}